import { getInstance } from '../../braze'

export { type BrazeInstance } from '../../braze'

export function getBrazeInstance() {
  return getInstance()
}
